import React, { useState, useEffect, useRef } from "react";
import { Table, Input, Skeleton, Tabs, Modal, Image, Form } from "antd";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import CustomButton from "../../../components/CustomButton";
import { fetchApi } from "../../lib/api";
import _ from "lodash";
import Pagination from "@material-ui/lab/Pagination";
import moment from "moment";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../_metronic/_partials/controls";
import SVG from "react-inlinesvg";

const LuckyUser = (props) => {
  const ref = useRef();
  const { intl } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [typeTab, setTypeTab] = useState(0);
  const [isModal, setIsModal] = useState(false);
  const [name, setName] = useState("");
  const [dataDe, setDataDe] = useState([]);
  const [loadMo, setLoadMo] = useState(false);
  const getHis = async (
    name,
    phone,
    page = 1,
    limit = 10,
    type = 0,
    id = ""
  ) => {
    try {
      setIsLoading(true);
      const res = await fetchApi(
        `/admin/rewards/get-history-rewards?page=${page}&limit=${limit}&type=${type}&id=${id}&name=${name ||
          ""}&phone=${phone || ""}`
      );

      setData(res?.data);
      setDataDe(res?.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      await getHis();
    })();
  }, []);

  //   const handleSearch = _.debounce(async (value) => {
  //     await getHis(value, undefined, undefined, typeTab);
  //   }, 800);

  const onChangePage = async (event, page) => {
    const { name, phone } = await ref.current.getFieldsValue();
    await getHis(name, phone, page, 10, typeTab);
  };

  const showDetails = async (data) => {
    setIsModal(!isModal);
    setName(data.fullname);
    setLoadMo(true);
    try {
      const res = await fetchApi(
        `/admin/rewards/get-history-rewards?text=&page=&limit=&type=${typeTab}&id=${data.id}`
      );
      setDataDe(res?.data);
      setLoadMo(false);
    } catch (error) {
      setLoadMo(false);
    }
  };

  const handleSearch = async () => {
    const { name, phone } = await ref.current.getFieldsValue();
    if (!name && !phone) {
      return;
    }
    await getHis(name, phone, undefined, undefined, typeTab);
  };

  return (
    <>
      <Modal
        title={name}
        open={isModal}
        onOk={() => {
          setIsModal(!isModal);
          setName("");
        }}
        onCancel={() => {
          setIsModal(!isModal);
          setName("");
        }}
        centered
        width={1200}
      >
        <Skeleton active loading={loadMo}>
          <Table
            scroll={{
              y: 500,
            }}
            columns={
              typeTab === 1
                ? [
                    {
                      title: "Tên",
                      dataIndex: "description",
                      key: "description",
                    },
                    {
                      title: "Số lượng",
                      dataIndex: "quantity",
                      key: "quantity",
                    },

                    {
                      title: "Thể loại",
                      dataIndex: "type",
                      key: "type",
                    },
                    {
                      title: "Thời gian",
                      dataIndex: "createdAt",
                      key: "createdAt",
                      render: (data, _) => (
                        <a>{moment().format("l", data?.createdAt)}</a>
                      ),
                    },
                  ]
                : [
                    {
                      title: "Tên phần thưởng",
                      dataIndex: "rewards",
                      key: "rewards",
                      render: (rewards, _) => <a>{rewards?.name_reward}</a>,
                    },
                    {
                      title: "Trị giá",
                      dataIndex: "rewards",
                      key: "rewards",
                      render: (rewards, _) => <a>{rewards?.amount}</a>,
                    },
                    {
                      title: "Thể loại",
                      dataIndex: "rewards",
                      key: "rewards",
                      render: (rewards, _) => <a>{rewards?.coin?.name}</a>,
                    },
                    {
                      title: "Hình ảnh",
                      dataIndex: "rewards",
                      key: "rewards",
                      render: (rewards, _) => (
                        <Image width={50} src={rewards?.coin?.logo} />
                      ),
                    },
                  ]
            }
            dataSource={
              dataDe?.data?.length > 0 ? dataDe?.data[0]?.history_rewards : []
            }
            pagination={false}
          />
        </Skeleton>
      </Modal>
      <Card>
        <CardHeader title={intl.formatMessage({ id: "SIDEBAR.LUCKY_MONEY" })} />
        <CardBody>
          <div>
            <h3 className="py-5">Danh sách người tham gia</h3>
            <Form ref={ref}>
              <div className="row">
                <div className="col-sm-3 mb--16">
                  <div className="customLabel">Tìm kiếm theo tên{` `}</div>
                  <Form.Item name="name">
                    <Input
                      className="width100"
                      placeholder="Tìm kiếm theo tên..."
                      //   onChange={(e) => handleSearch(e.target.value)}
                    />
                  </Form.Item>
                </div>
                <div className="col-sm-3 mb--16">
                  <div className="customLabel">
                    Tìm kiếm theo số điện thoại{` `}
                  </div>
                  <Form.Item name="phone">
                    <Input
                      className="width100"
                      placeholder="Tìm kiếm theo số điện thoại..."
                      //   onChange={(e) => handleSearch(e.target.value)}
                    />
                  </Form.Item>
                </div>

                <div className="mb--16">
                  <div className="customLabel pt-5"></div>
                  <CustomButton
                    className="mr--10"
                    title="Tìm kiếm"
                    btnBgColor="#3699ff"
                    btnColor="#ffffff"
                    btnHoverBackground="#187de4"
                    onClick={handleSearch}
                  />
                </div>
                <div className="mb--16">
                  <div className="customLabel pt-5"></div>
                  <CustomButton
                    className="customClearSearch mr--10"
                    title="Bỏ lọc"
                    btnBgColor="#eceef7"
                    btnColor="#192038"
                    btnHoverBackground="#eceef7"
                    onClick={async () => {
                      await getHis();
                      await ref.current.resetFields();
                    }}
                  />
                </div>
              </div>
            </Form>
            <div>
              <Skeleton active loading={isLoading}>
                <Table
                  columns={[
                    {
                      title: "Tên người dùng",
                      dataIndex: "fullname",
                      key: "fullname",
                    },
                    {
                      title: "Email",
                      dataIndex: "email",
                      key: "email",
                    },
                    {
                      title: "Số điện thoại",
                      dataIndex: "mobile",
                      key: "mobile",
                    },
                    {
                      title: "Xem chi tiết",
                      dataIndex: "rewards",
                      key: "rewards",
                      render: (rewards, _) => (
                        <span
                          className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                          onClick={() => showDetails(_)}
                        >
                          <span className="svg-icon svg-icon-md svg-icon-primary">
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/Communication/Write.svg"
                              )}
                            />
                          </span>
                        </span>
                      ),
                    },
                  ]}
                  dataSource={data?.data}
                  pagination={false}
                />
              </Skeleton>

              {data?.total > data?.limit && (
                <div className="mt--20 rowx-center">
                  <Pagination
                    count={Math.ceil(data?.total / data?.limit)} //total
                    page={Number(data?.page)} //current page
                    variant="outlined"
                    shape="rounded"
                    showFirstButton
                    showLastButton
                    onChange={(event, page) => onChangePage(event, page)}
                  />
                </div>
              )}
            </div>
          </div>
        </CardBody>
      </Card>
    </>
  );
};

export default injectIntl(withRouter(LuckyUser));
